// 发通知 到cocos侧
export function postMessage({type, value, ref, ...data}){
    let ele = ref && ref.contentWindow || window
    let div = document.getElementById('iframe')
    if(div){
        ele = div
        ele.contentWindow.postMessage(
            {
                type: 'cocos' + type,
                value,
                ...data
            },
            '*',
        );
        return false
    }
    ele.postMessage(
        {
            type: 'cocos' + type,
            value,
            ...data
        },
        '*',
    );
}
// 发通知 到web侧
export function postMessageWeb({type, value, ref, callback, ...data}){
    const ele = ref && ref.contentWindow || window
    ele.postMessage(
        {
            type: 'web' + type,
            value,
            callback,
            ...data
        },
        '*',
    );
}
// 获取消息
export function getMessage(func){
    window.onmessage = (e) => {
        func(e)
    }
}

// 获取鼠标是否右击
export function getMouseRight(func){
    document.addEventListener("contextmenu", function (event) {
        event.preventDefault();
        // console.log('contextmenu==>',event)
        func(event)
    });
}
// 获取鼠标是否左击
export function getMouseLeft(func){
    document.onclick = function (event) {
        // event.preventDefault();
        // console.log('onclick==>',event)
        func(event)
    };
}
